import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { IconComponent } from '@libs/components/icons';
import { NavItemModel, NavModel } from '@libs/shared/models';

@Component({
  selector: 'ui-nav-menu-tree',
  templateUrl: './menu-tree.component.html',
  styleUrls: ['./menu-tree.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    NgTemplateOutlet,
    NgClass,
    IconComponent,
  ],
})
export class MenuTreeComponent {
  @Input() public root!: NavModel;
  @Output() public selected: EventEmitter<NavItemModel> =
    new EventEmitter<NavItemModel>();
}
